import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { TranslatedText } from '..';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';
interface BranchSelectProps {
  objName: string;
}
export const BranchSelect = ({ objName }: BranchSelectProps) => {
  const form = Form.useFormInstance();
  const { getBranchOptions } = useUniStudyBranchesOptions();
  const options = getBranchOptions();
  const { t } = useTranslation('StudentOnboardingPageTranslations');

  return (
    <Box flexDirection="column" gap={12}>
      <TranslatedText i18nKey="BRANCH_GOAL" />
      <Form.Item name={['userInfo', objName, 'studyBranch']} rules={[RULES.REQUIRED]}>
        <Select
          options={options}
          placeholder={t('SELECT_BRANCH')}
          onChange={() => {
            form.setFieldValue(['userInfo', objName, 'degree'], undefined);
            form.setFieldValue(['userInfo', objName, 'university'], undefined);
            form.setFieldValue(['userInfo', objName, 'otherUniversity'], undefined);
            form.setFieldValue(['userInfo', objName, 'otherDegree'], undefined);
          }}
        />
      </Form.Item>
    </Box>
  );
};
